/* eslint-disable react/prop-types */
import React from 'react';
import Avatar from '@ublend-npm/aulaui-next-web/Avatar';
import ArrowIcon from '@material-ui/icons/KeyboardArrowDown';
import { Button, iconClass, Title, SpaceContainer } from './ToolButton.styled';

const ToolButton = ({ compact, onClick, tool }) => (
  <Button
    compact={compact}
    onClick={onClick}
    variant="contained"
    size="small"
    data-testid="new-assignment-tool"
    aria-label={`${tool.name} tool`}
  >
    <SpaceContainer>
      <Avatar src={tool.logo} size="small" name={tool.name} />
      <Title>{tool.name}</Title>
    </SpaceContainer>
    <ArrowIcon className={iconClass} />
  </Button>
);

export default ToolButton;
